function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "where_to_vote_24px"
}, React.createElement("path", {
  id: "icon/content/where_to_vote_24px",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 9.265C5 5.405 8.14001 2.265 12 2.265C15.86 2.265 19 5.405 19 9.265C19 13.435 14.58 19.185 12.76 21.375C12.36 21.855 11.63 21.855 11.23 21.375C9.42001 19.185 5 13.435 5 9.265ZM11.18 13.555L16.31 8.42499C16.7 8.03499 16.7 7.405 16.32 7.00499C15.93 6.61499 15.29 6.61499 14.9 7.00499L10.48 11.425L9.12 10.065C8.73001 9.67499 8.09 9.67499 7.70001 10.065C7.31 10.455 7.31 11.095 7.70001 11.485L9.76999 13.555C10.16 13.945 10.79 13.945 11.18 13.555Z",
  fill: "black",
  fillOpacity: 0.54
}));

var SvgGambut = function SvgGambut(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGambut, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gambut.3e78b505.svg";
export { ForwardRef as ReactComponent };